import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintApiManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_translate_serial_number_from_footprint_to_public_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { footprint_serial_numbers: any[] }): Promise<{ public_serial_numbers: $frontendTypes.FootprintApiManager.public_serial_number[], errors?: string[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.footprint_serial_numbers)) {
      $missingRequiredInParams.push('\'footprint_serial_numbers\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

